import { useFormik } from "formik";
import { validationSchema } from "../validations/validationWebservice";

export const useFormWebserviceSmry = ({ onSubmit }) => {
  return useFormik({
    initialValues: {
      period: {
        dateFrom: "",
        dateTo: "",
      },
      uid_partner: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {

      const dataToSubmit = {
        from: values?.period?.dateFrom,
        to: values?.period.dateTo,
        uid_partner: values?.uid_partner,
      };

      onSubmit(dataToSubmit);
    },
  });
};
